import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import invariant from '../utils/invariant';
import Client from './Client';
/**
 * @param {?object} config
 * @param {?object} interceptors
 */

function createApi(config, interceptors) {
  /**
   * @type {Client}
   */
  var _client = new Client(config, interceptors);

  return function (Base) {
    invariant(typeof Base === 'function', 'Base expected a class, instead received %s.', Base);

    var Api =
    /*#__PURE__*/
    function (_Base) {
      _inherits(Api, _Base);

      _createClass(Api, null, [{
        key: "getClient",

        /**
         * @static
         * @returns {Client}
         */
        value: function getClient() {
          return _client;
        }
        /**
         * @static
         * @param {?object} config
         * @returns {Client}
         */

      }, {
        key: "setConfig",
        value: function setConfig(config) {
          return _client.setConfig(config);
        }
        /**
         * @static
         * @param {?object} interceptors
         * @returns {Client}
         */

      }, {
        key: "setInterceptors",
        value: function setInterceptors(interceptors) {
          return _client.setInterceptors(interceptors);
        }
        /**
         * @static
         * @returns {?object}
         */

      }, {
        key: "getConfig",
        value: function getConfig() {
          return _client.getConfig();
        }
        /**
         * @static
         * @returns {?object}
         */

      }, {
        key: "getInterceptors",
        value: function getInterceptors() {
          return _client.getInterceptors();
        }
        /**
         * @static
         * @param {?object} config
         * @returns {Client}
         */

      }, {
        key: "updateConfig",
        value: function updateConfig(config) {
          return _client.updateConfig(config);
        }
        /**
         * @static
         * @param {?object} auth
         * @returns {Client}
         */

      }, {
        key: "authorize",
        value: function authorize(auth) {
          return _client.authorize(auth);
        }
        /**
         * @constructor
         * @param {?object} options
         */

      }]);

      function Api(options) {
        _classCallCheck(this, Api);

        return _possibleConstructorReturn(this, _getPrototypeOf(Api).call(this, _objectSpread({}, options, {
          client: _client
        })));
      }

      return Api;
    }(Base);

    return Api;
  };
}

export default createApi;